// hooks/useEscapeKey.js
import { useEffect } from 'react';

export default function useEscapeKey(onClose, isOpen) {
    useEffect(() => {
        const onKeyDown = (e) => {
            if (e.key === 'Escape' && isOpen) onClose();
        };
        window.addEventListener('keydown', onKeyDown);
        return () => window.removeEventListener('keydown', onKeyDown);
    }, [isOpen, onClose]);
}